import { IconCode } from "@multiweb/types/contracts";
import { LOC_KEY_MENU_PANEL_QUICK_ACCESS, LOC_KEY_MENU_PANEL_USER } from "./locKeys";
import { MenuItemActivatedType, MenuPanelItems, MenuPanelItemType } from "./types";

export const UNKNOWN_ITEM_ICON_CODE = IconCode.uiHelp;

export enum MenuPanelItemId {
    logo = "LOGO",
    quickAccess = "QUICK_ACCESS",
    user = "USER",
    expandButton = "EXPAND_BUTTON",
}

export const STATIC_MENU_PANEL_ITEMS: MenuPanelItems = {
    [MenuPanelItemId.quickAccess]: {
        id: MenuPanelItemId.quickAccess,
        locKey: LOC_KEY_MENU_PANEL_QUICK_ACCESS,
        iconCode: IconCode.uiChevronRightTripple,
        type: MenuPanelItemType.static,
        activationType: MenuItemActivatedType.staticPanelItem,
    },
    [MenuPanelItemId.user]: {
        id: MenuPanelItemId.user,
        locKey: LOC_KEY_MENU_PANEL_USER,
        iconCode: IconCode.user,
        type: MenuPanelItemType.static,
        activationType: MenuItemActivatedType.staticPanelItem,
    },
};

export const ICON_CODE_EXPAND_MENU = IconCode.webCollapseRight;
export const ICON_CODE_COLLAPSE_MENU = IconCode.webCollapseLeft;
